module.exports = __webpack_public_path__ + "img/許力文.dcfc79f8.jpg";